import React, { useEffect, useState } from "react";
import "./App.css";
import Homepage from "./feature/pages/homepage/Homepage";
import { useAuth } from "react-oidc-context";
import { Box, CircularProgress, Button, Typography } from "@mui/material";

function App() {
  const auth = useAuth();
  const [loginAttempted, setLoginAttempted] = useState(false);

  // Consolidate authentication logic: URL cleanup -> signin redirect
  useEffect(() => {
    if (auth.isLoading) return;

    // 1. Clean up URL params from logout or redirect if needed
    if (!auth.isAuthenticated && window.location.search) {
      const params = new URLSearchParams(window.location.search);
      if (params.has('code') || params.has('state')) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }

    // 2. If there's an auth error, stop and show error UI
    if (auth.error) {
      console.error('Auth error:', auth.error);
      return;
    }

    // 3. If unauthenticated and not already navigating, trigger signin
    if (!auth.isAuthenticated && !auth.activeNavigator && !loginAttempted) {
      setLoginAttempted(true);
      auth.signinRedirect();
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, auth.activeNavigator, loginAttempted]);

  // Show spinner while loading
  if (auth.isLoading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Show error UI if authentication failed
  if (auth.error) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        gap={2}
      >
        <Typography variant="h6" color="error">
          Login Failed
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {auth.error.message || 'An authentication error occurred.'}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setLoginAttempted(false);
            auth.signinRedirect();
          }}
        >
          Try Again
        </Button>
      </Box>
    );
  }

  // Strict guard: if not authenticated, render nothing
  if (!auth.isAuthenticated) {
    return null;
  }

  return (
    <div className="App">
      <Homepage />
    </div>
  );
}

export default App;
